module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-wrapper"
  }, [_c('img', {
    staticClass: "logo-image",
    attrs: {
      "src": require("../../static/images/logo.png")
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.info.title))]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), (_vm.info.galleryMini) ? _c('div', {
    staticClass: "carousel"
  }, [_c('carousel', {
    ref: "gallery",
    attrs: {
      "navigationEnabled": true,
      "paginationEnabled": false,
      "perPage": 1
    }
  }, _vm._l((_vm.info.galleryMini), function(img, index) {
    return _c('slide', {
      key: index
    }, [_c('div', {
      staticClass: "slider-image-wrapper"
    }, [_c('img', {
      staticClass: "slider-image",
      attrs: {
        "src": img
      },
      on: {
        "click": _vm.galleryOnClick
      }
    })])])
  })), _vm._v(" "), _c('div', {
    staticClass: "image-note"
  }, [_vm._v(_vm._s(_vm.galleryLabel))])], 1) : _vm._e(), _vm._v(" "), (_vm.info.image) ? _c('div', [_c('img', {
    staticClass: "cover-image",
    attrs: {
      "src": _vm.info.image
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "info-text",
    domProps: {
      "innerHTML": _vm._s(_vm.info.description)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "navigation-wrapper"
  }, [_c('button', {
    staticClass: "navigation-link left",
    attrs: {
      "disabled": !_vm.showPrevLink
    },
    on: {
      "click": function($event) {
        _vm.toggleMarker('prev')
      }
    }
  }, [_vm._v("Previous")]), _vm._v(" "), _c('button', {
    staticClass: "navigation-link",
    on: {
      "click": function($event) {
        _vm.toggleMarker('home')
      }
    }
  }, [_vm._v("Home")]), _vm._v(" "), _c('button', {
    staticClass: "navigation-link right",
    attrs: {
      "disabled": !_vm.showNextLink
    },
    on: {
      "click": function($event) {
        _vm.toggleMarker('next')
      }
    }
  }, [_vm._v("Next")])]), _vm._v(" "), (_vm.info.embed) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.info.embed)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showScrollHint) ? _c('div', {
    staticClass: "scroll-hint bounce"
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-519ed934"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Info.vue
// module id = 132
// module chunks = 1